import './styles.css';
import { App, ALL_LEVELS } from './app';
import { initPwa } from './pwa';

initPwa();
import type { Quality } from './render/stage';

function pickQuality(): Quality {
  const q = new URLSearchParams(location.search).get('quality');
  if (q === 'low' || q === 'medium' || q === 'high') return q;
  const mem = (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 4;
  const cores = navigator.hardwareConcurrency ?? 4;
  const small = Math.min(screen.width, screen.height) < 500;
  if (mem <= 2 || cores <= 2) return 'low';
  if (small || mem <= 4) return 'medium';
  return 'high';
}

const app = new App(document.getElementById('app')!, pickQuality());
const params = new URLSearchParams(location.search);
const level = ALL_LEVELS.find((l) => l.id === params.get('level'));
if (level) {
  app.startLevel(level);
  app.showGate();
} else if (params.has('free')) {
  app.startFree();
  app.showGate();
} else {
  app.startFree();
  app.showGate();
}

// For debugging and automated smoke tests.
(window as unknown as { zapboard: App }).zapboard = app;
